export enum AdminTabValue {
  companies = "companies",
  signups = "signups",
  plans = "plans",
  applications = "applications",
  campaigns = "campaigns",
  configCategories = "configCategories",
  blocklist = "blocklist",
  reports = "reports",
}
